import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'currencyNumber'
})
export class CurrencyNumberPipe implements PipeTransform {

  transform(val: number): string {

    if (val !== undefined && val !== null) {
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
    } else {
      return '0';
    }
  }
}



// WEBPACK FOOTER //
// D:/Projects/mvdclick/frontend/src/app/pipes/currency.ts